import clsx from 'clsx';
import { Form } from 'react-bootstrap';
import classes from './SimpleCheckbox.module.css';
const SimpleCheckbox = ({ label, className, checked, setter, id, ...rest }) => {
  return (
    <>
      <style jsx>{`
        .simple-checkbox input {
          border: 2px solid var(--placeholder-color) !important;
          height: 16px;
          width: 16px;
          cursor: pointer;
        }
        .simple-checkbox input:focus {
          border-color: var(--placeholder-color) !important;
          outline: 0;
          box-shadow: initial !important;
          display: block;
        }
        input.form-check-input:checked {
          background-color: var(--primary-color) !important;
          border-color: var(--primary-color) !important;
        }
        input.form-check-input:not(:checked) {
          border-color: var(--placeholder-color) !important;
        }
      `}</style>

      <Form.Check // prettier-ignore
        className={clsx(className, classes.checkbox, 'simple-checkbox')}
        type={'checkbox'}
        id={id}
        checked={checked}
        onChange={(e) => {
          setter && setter(e);
        }}
        {...rest}
      />
    </>
  );
};

export default SimpleCheckbox;
